import axiosInstance from "../../../services/axiosInstance";
import axiosInstanceMultipart from "../../../services/axiosInstanceMultipart";
import axiosInstanceNoToken from "../../../services/axiosInstanceNoToken";


export const getCart = async (request = {}) => {
    const response = await axiosInstance.post('calculate-cart',  request );
    return response.data;
};
export const checkCode = async (code) => {
    const response = await axiosInstance.get(`payments/discount-code/${code}` );
    return response.data;
};

export const handlePayment = async (request) => {
    const response = await axiosInstance.post(`payments/handle-payments` , request);
    return response.data;
};

export const handlePaymentWallet = async (request) => {
    const response = await axiosInstance.post(`payments/handle-payments-wallet` , request);
    return response.data;
};
export const getAddresses = async (params) => {
    const response = await axiosInstance.get(`addresses` , {params});
    return response.data;
};
export const getOrders = async (params = null) => {
    const response = await axiosInstance.get(`orders` , {params});
    return response.data;
};
export const getStatuses = async (params = null) => {
    const response = await axiosInstanceNoToken.get(`statuses` , {params});
    return response.data;
};
export const getOrder = async (id, params = null) => {
    const response = await axiosInstance.get(`orders/${id}` , {params});
    return response.data;
};
export const updateStatus = async (request = null) => {
    const response = await axiosInstance.patch('update-order-status' , request);
    return response.data;
};
export const storeRating = async (request = null) => {
    const response = await axiosInstance.post('reviews' , request);
    return response.data;
};

export const quickSearch = async (id, params = null) => {
    const response = await axiosInstanceNoToken.get(`products/quick-search/${id}` , {params});
    return response.data;
};


export const storeTicket = async (request = null) => {
    const response = await axiosInstance.post('tickets' , request);
    return response.data;
};

export const getTickets = async (params = null) => {
    const response = await axiosInstance.get(`tickets` , {params});
    return response.data;
};

export const getTicket = async (id, params = null) => {
    const response = await axiosInstance.get(`tickets/${id}` , {params});
    return response.data;
};

export const updateTicket = async (id,request = null) => {
    const response = await axiosInstanceMultipart.post(`tickets/${id}`,request  );
    return response.data;
};

export const getCalls = async (params = null) => {
    const response = await axiosInstance.get(`crm-get-calls` , {params});
    return response.data;
};